import I18n from 'i18n-js';
import React from 'react';
import { shuffle, isEqual } from 'lodash';

import OverflowingRow from '@reverbdotcom/commons/src/components/overflowing_row';
import Tiles from '@reverbdotcom/commons/src/components/tiles';

import { V3 } from '../api_request';
import URLHelpers from '../shared/url_helpers';
import { CURATED_SET_ROW_LENGTH } from '../shared/constants';
import CuratedSet from '../discovery/curated_set';
import CuratedSetCard from '../discovery/curated_set_card';

interface IProps {
  shouldShuffle?: boolean;
  showHeading?: boolean;
  linkParams?: Record<string, any>;
  title?: string;
  action?: JSX.Element;
  centeredTitle?: boolean;
  ids: string[];
}

interface InternalProps extends IProps {
  curatedSets?: CuratedSet[];
  title?: string;
}

export class CuratedSetRow extends React.Component<InternalProps, null> {
  static defaultProps: Partial<InternalProps> = {
    shouldShuffle: true,
    centeredTitle: false,
  };

  hasEnoughCuratedSets() {
    return this.props.curatedSets &&
      this.props.curatedSets.length >= CURATED_SET_ROW_LENGTH;
  }

  getHeading() {
    if (!this.props.showHeading && !this.props.title) { return null; }

    return this.props.title || I18n.t('discovery.curatedSetRow.header');
  }

  render() {
    if (!this.hasEnoughCuratedSets()) { return null; }

    const curatedSets = this.props.shouldShuffle ?
      shuffle(this.props.curatedSets) as CuratedSet[] :
      this.props.curatedSets;

    return (
      <OverflowingRow
        title={this.getHeading()}
        centeredTitle={this.props.centeredTitle}
        action={this.props.action}
      >
        <Tiles
          largeTiles
          singleRow
          grow
        >
          {curatedSets.map((curatedSet, idx) => (
            <CuratedSetCard
              curatedSet={curatedSet}
              linkParams={this.props.linkParams}
              key={idx}
            />
          ))}
        </Tiles>
      </OverflowingRow>
    );
  }
}

interface IState {
  curatedSets?: CuratedSet[];
}

// TODO: mapAjaxToProps should be used here, but it doesn't refetch on prop updates.
// That should be fixed.
export default class ConnectedCuratedSetRow extends React.Component<IProps, IState> {
  state = {
    curatedSets: [],
  };

  componentDidMount() {
    this.fetch(this.props.ids);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.ids, this.props.ids)) {
      this.fetch(this.props.ids);
    }
  }

  fetch(ids: string[]) {
    if (ids.length === 0) {
      return;
    }

    const params = {
      id: ids.slice(0, CURATED_SET_ROW_LENGTH),
      thumb_size: 'card_wide',
    };

    return V3.get(URLHelpers.curatedSetsPath(), params).then((res) => {
      this.setState({ curatedSets: res.curated_sets });
    });
  }

  render() {
    return (
      <CuratedSetRow {...this.props} curatedSets={this.state.curatedSets} />
    );
  }
}
